

const { classesRuntime, statesRuntime } = require("./../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_146_2_easing";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_146_2_easing__root"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {"speed-fast-1":"100ms","speed-fast-2":"150ms","speed-medium-1":"200ms","speed-medium-2":"300ms","speed-slow-1":"400ms","speed-slow-2":"500ms","speed-slow-02":"600ms","ease-1":"cubic-bezier(0.23, 1, 0.32, 1)","ease-2":"cubic-bezier(0.25, 0.46, 0.45, 0.94)","ease-3":"cubic-bezier(0, 0, 0.2, 1)","ease-4":"cubic-bezier(0.4, 0.0, 1, 1)","ease-5":"cubic-bezier(0.81, 0, 1, 1)","ease-6":"cubic-bezier(0.18, 0.89, 0.32, 1.28)","ease-7":"cubic-bezier(0.19, 1, 0.22, 1)","ease-8":"ease-in-out","ease-9":"linear"}; 
module.exports.vars = {}; 




